<template>
  <div class="animated fadeIn py3">
    <div class="clearfix gibson px3 mb2">
      <div class="col-12 px0">
        <div class="notosans">
            <p class="h4 darkblue line-height-golden">Billeder</p>
            <p :show="noImage" class="h5 darkblue regular gibson mb2 line-height-3">
              Start med at uploade billeder
            </p>
            <p class="h6 darkblue gibson" :v-html="images.length + ' Billede'"></p>
            <div class="clearfix flex flex-wrap mb2">
              <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
              <div v-for="image in images" :key="image">
                <div class="px2 flex flex-column justify-center items-center mb2">
                  <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                  <button @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="py4"></div>
  </div>
</template>
<script>
export default {
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    var projectId = this.$route.query.id
    if (projectId !== undefined) {
      this.seen = true
    }
  },
  data: function () {
    return {
      projects: 0,
      projects_create: 0,
      seen: true,
      miniprofile: ''
    }
  },
  methods: {
    UpdateProject (projects, projectsCreate) {
      this.projects = projects
      this.projects_create = projectsCreate
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// uploadimage.vue?2453dc9f